import { t } from '@lingui/macro'
import { Card, CardContent, CardHeader } from '@material-ui/core'
import { css } from 'emotion'
import React from 'react'

import { i18n } from '../i18n'
import { useRoot } from './RootProvider'

interface IProps {
  title: ReactNode | string
  admin?: boolean
  noGutter?: boolean
}

const gutter = css`
  margin-top: 1rem;
  margin-left: 1rem;
`

export const Brick: React.FC<IProps> = ({
  title,
  admin,
  noGutter = false,
  children,
}) => {
  const { auth } = useRoot()
  if (admin !== undefined && auth.isAdmin !== admin) {
    return null
  }
  return (
    <Card classes={{ root: !noGutter ? gutter : '' }}>
      <CardHeader
        title={title}
        subheader={admin === true ? i18n._(t`Pouze pro administrátora`) : ''}
      />
      <CardContent>{children}</CardContent>
    </Card>
  )
}
